export { LegacyLocationServiceSupport } from "./LegacyLocationServiceSupport";
